import { MenuItemsType, DropdownMenuItemType } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'
import { nftsBaseUrl } from 'views/Nft/market/constants'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const config: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => {
  const isHODLApp = typeof window !== 'undefined' && !!window.ethereum?.isHODLApp

  return [
    ...(!isHODLApp
      ? [
          {
            label: t('Swap'),
            href: '/swap',
            icon: 'Swap',
            showItemsOnMobile: false,
          },
        ]
      : []),
    // {
    //   label: t('Farm'),
    //   href: '/farms/history',
    //   icon: 'Farm',
    //   showItemsOnMobile: false,
    // },
    // {
    //   label: t('Stake'),
    //   href: '/pools',
    //   icon: 'Pool',
    //   showItemsOnMobile: false,
    // },
    {
      label: t('NFTs'),
      href: '/nft-pools',
      icon: 'Nft',
      showItemsOnMobile: false,
    },
    // {
    //   label: t('Specials'),
    //   href: '/earn/history',
    //   icon: 'Pool',
    //   showItemsOnMobile: false,
    // },
    // {
    //   label: t('Remove LP'),
    //   href: '/liquidity',
    //   icon: 'Add',
    //   showItemsOnMobile: false,
    // },
    // {
    //   label: t('Referrals'),
    //   href: '/referral',
    //   icon: 'Groups',
    //   showItemsOnMobile: false,
    // },
  ]
}

export default config
